<template>
    <div class="bg-white">
        <Head>
            <title>{{ product.name }}</title>
        </Head>
        <Header :pageName="product.name" :cart-count="cartCount"/>
        <flash-message :message="flash.error"/>
        <flash-message :message="flash.success"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <!-- Image -->
                <div>
                    <img v-if="product.images"
                         :src="`/storage/${product.images}`"
                         :alt="product.name"
                         class="w-full rounded-lg object-cover"/>
                    <div v-else class="w-full h-64 flex items-center justify-center bg-gray-100 rounded-lg text-gray-400">
                        Без фото
                    </div>
                    <form v-if="product.in_stock" class="mt-8 space-y-4" @submit.prevent="addToCart">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Кількість *</label>
                            <input
                                v-model.number="form.quantity"
                                type="number"
                                min="1"
                                :max="product.quantity"
                                required
                                class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-sky-500"
                            />
                            <p v-if="form.errors.quantity" class="mt-1 text-sm text-red-500">{{ form.errors.quantity }}</p>
                        </div>

                        <div class="pt-2 border-t border-gray-100">
                            <p class="text-xl font-semibold">
                                До сплати: <span class="text-sky-700">{{ totalPrice }} грн</span>
                            </p>
                        </div>

                        <button
                            type="submit"
                            :disabled="form.processing"
                            class="btn-indigo btn-booking modal-booking-btn"
                        >
                            {{ form.processing ? 'Додаємо...' : 'Додати до кошика' }}
                        </button>
                    </form>
                </div>

                <!-- Details & add to cart form -->
                <div>
                    <h2 class="page-title">{{ product.name }}</h2>

                    <p class="mt-4 text-3xl font-bold text-sky-700">{{ product.price }} грн</p>

                    <p v-if="!product.in_stock" class="mt-2 text-red-500 font-medium">Немає в наявності</p>
                    <p v-else class="mt-2 text-green-600 font-medium">В наявності: {{ product.quantity }} шт.</p>
                    <div class="mt-6 leading-7 prose max-w-none" v-html="product.description"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Header from '@/Component/Header'
import FlashMessage from '@/Component/FlashMessage'

export default {
    components: {Head, Header, Link, FlashMessage},
    props: {
        product: {type: Object, required: true},
        cartCount: {type: Number, default: 0},
    },
    data() {
        return {
            flash: this.$page.props.flash || {},
            form: this.$inertia.form({
                quantity: 1,
            }),
        }
    },
    computed: {
        totalPrice() {
            return (this.product.price * (this.form.quantity || 1)).toFixed(2)
        },
    },
    methods: {
        addToCart() {
            this.form.post(this.$route('cart.products.add', this.product.id))
        },
    },
}
</script>
